import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    fontSize: theme.size.sm
  },

  stats: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    marginBottom: '0.25rem'
  },

  stat: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '0.25rem',

    '& > :first-child': {
      marginRight: '0.5rem'
    }
  },

  tagList: {
    display: 'flex',
    flexWrap: 'wrap'
  },

  tag: {
    marginTop: '0.25rem',
    marginRight: '0.25rem',
    border: '1px solid #C6C6C6',
    borderRadius: '4px',
    boxSizing: 'border-box',
    width: 'max-content',
    padding: '4px 8px',
    background: '#F5F6F8',
    color: '#8F8F8F'
  },

  controls: {
    display: 'flex',
    alignItems: 'center',
    width: 'fit-content'
  },

  dragHandle: {
    display: 'flex',
    alignItems: 'center'
  },

  dragIcon: {
    marginRight: '0.5rem',
    cursor: 'pointer'
  },

  count: {
    color: theme.palette.primary.main,
    display: 'flex',
    alignItems: 'center',
    borderRadius: 3,
    border: '2px solid transparent',
    padding: '2px',
    userSelect: 'none',

    '&:hover': {
      backgroundColor: theme.palette.secondary.main
    },

    '& .count': {
      marginRight: '4px'
    },

    '& .icon': {
      display: 'flex',
      alignItems: 'center',
      color: theme.palette.textAlt
    }
  },

  countSelected: {
    borderBottomColor: theme.palette.primary.main
  },

  icon: {
    color: theme.palette.textAlt,
    transform: 'rotate(90deg)'
  }
}))

export default useStyles
